import { render, staticRenderFns } from "./GeneralDonutChart.vue?vue&type=template&id=c87cc0a2&scoped=true&"
import script from "./GeneralDonutChart.vue?vue&type=script&lang=js&"
export * from "./GeneralDonutChart.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDonutChart.vue?vue&type=style&index=0&id=c87cc0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87cc0a2",
  null
  
)

export default component.exports